import { useNavigate } from 'react-router-dom';
import { ConnectedAccountsSection } from '@/components/inbox/ConnectedAccountsSection';
import { BackButton } from '@/components/shared/BackButton';

const SETTINGS_SECTIONS = [
  {
    label: 'Filters & Rules',
    description: 'Automatically label, archive, or link emails matching conditions',
    route: '/barrister/inbox/settings/filters',
    icon: '≡',
  },
  {
    label: 'Templates',
    description: 'Pre-written emails for common barrister correspondence',
    route: '/barrister/inbox/settings/templates',
    icon: '⧉',
  },
  {
    label: 'Signatures',
    description: 'Professional signatures for new messages and replies',
    route: '/barrister/inbox/settings/signatures',
    icon: '✍',
  },
  {
    label: 'Labels',
    description: 'Organise emails with custom colour-coded labels',
    route: '/barrister/inbox/settings/labels',
    icon: '⬩',
  },
  {
    label: 'General',
    description: 'Reading pane, density, conversation mode, undo send',
    route: '/barrister/inbox/settings/general',
    icon: '⚙',
  },
];

export default function InboxSettingsHubPage() {
  const navigate = useNavigate();

  return (
    <div
      className="pb-24"
      style={{
        fontFamily: "'IBM Plex Sans', sans-serif",
      }}
    >
      {/* Was hardcoded to the inbox. This page is reached from the sidebar (Sidebar.tsx) and from
          Settings → Connected accounts (catalogue.ts) as well as from the inbox, so a fixed
          destination sent people somewhere they had never been. Back means back. */}
      <BackButton onClick={() => navigate(-1)} />

      <div className="mb-8">
        <h1 className="text-2xl font-bold tracking-tight text-foreground">
          Email settings
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Configure your email workspace
        </p>
      </div>

      {/* Which account is connected — and the control to disconnect it. First, because
          "whose mailbox is Jurivoxa reading?" outranks every preference below it. */}
      <ConnectedAccountsSection />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {SETTINGS_SECTIONS.map((s) => (
          <div
            key={s.route}
            onClick={() => navigate(s.route)}
            style={{
              display: 'flex', alignItems: 'center', gap: 16,
              padding: '16px 20px', borderRadius: 8,
              border: '1px solid var(--border-default)', background: 'var(--surface-card)',
              cursor: 'pointer', marginBottom: 8,
              transition: 'background 0.1s',
            }}
            /*
              These handlers used to write the literal colours '#f9fafb' and 'white'. Writing an
              inline background PERMANENTLY overrides `background: var(--surface-card)` on the
              element, so in dark mode the first mouse-over turned a card white and left it white —
              with near-white text on it, measured at 1.05:1, i.e. an invisible title. It only
              affected cards the pointer had crossed, which is why it looked intermittent.
              Restoring to the TOKEN keeps the element theme-aware after the hover ends.
            */
            onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--surface-hover)')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'var(--surface-card)')}
          >
            <div style={{
              width: 40, height: 40, borderRadius: 8,
              background: '#1e3a5f', color: 'white',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 18, flexShrink: 0,
            }}>
              {s.icon}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--text-primary)' }}>{s.label}</div>
              <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 2 }}>{s.description}</div>
            </div>
            {/* --text-subtle measured 2.55–2.79:1 here; --text-muted clears AA in both themes and
                keeps the chevron visually secondary to the label. */}
            <span style={{ color: 'var(--text-muted)', fontSize: 16 }}>›</span>
          </div>
        ))}
      </div>
    </div>
  );
}
